// extracted by mini-css-extract-plugin
export default {"wrapper":"bbdce8e4dfe0","logo":"c86d9a2cac44","subheader":"e3c341496166","description":"a7d5752fa77a","productImpact":"c750d04fdd22"};